import React from 'react';
import ServicesEditTemplate from './services-edit-template'

const FingerPrintingService = () => {
    return <ServicesEditTemplate doc="fingerprinting" service="Fingerprinting" />;
};

export default FingerPrintingService;
